
import { useCallback,useEffect,useState } from "react";
import { useWallet } from "use-wallet";
import { useLockedContract } from "./useContract";
import {SendFun,CallFun } from '../utils/contract';
import useWeb3 from './useWeb3';

function useLocked(address) {
  const { account } = useWallet();
  const web3 = useWeb3();
  const [lockedBalance, setLockedBalance] = useState({});
  const contract= useLockedContract(address);
  const { getBlockNumber } = useWallet();
  const blockNumber = getBlockNumber();
  
     // 用户提现
    // function withdraw(uint256 amount) public whenNotPaused {

      const withdraw = useCallback(
        async (amount , setLoading, isErc20,ErrFun) => {
          return await SendFun(
            contract,
            account,
            "withdraw",
            [ amount ],
            setLoading,
            isErc20?0:amount,
            ErrFun
            );
        },
        [account, contract]
      );

  //   function lockedTokens (address user,uint256 amount) public payable whenNotPaused {
  const lockedTokens = useCallback(
    async (user, amount,pledgedays,gapdays,startprenum , setLoading, isErc20) => {
      return await SendFun(
        contract,
        account,
        "lockedTokens",
        [ user, amount,pledgedays,gapdays,startprenum ],
        setLoading,
        isErc20 ? null : amount
      );
    },
    [account, contract]
  );

  // 当合约余额不够时，向合约地址充值
  // function deposit(uint256 amount) payable public {
  const deposit = useCallback(
    async (amount, setLoading) => {
      return await SendFun(
        contract,
        account,
        "deposit",
        [ amount ],
        setLoading
      );
    },
    [account, contract]
  );

  const getToken = useCallback(
    async ( setLoading) => {
      return await CallFun(
        contract,
        account,
        "getToken",
        [  ],
        setLoading
      );
    },
    [account, contract]
  );

  const setToken = useCallback(
    async (newtoken, setLoading) => {
      return await SendFun(
        contract,
        account,
        "setToken",
        [  newtoken],
        setLoading
      );
    },
    [account, contract]
  );


  const getLokedRule = useCallback(
    async (setLoading) => {
      const res= await CallFun(
        contract,
        account,
        "getLokedRule",
        [ account ],
        setLoading
      );
      if (res){
        return {
          gapdays:res[0],
          pledgedays:res[1],
          startprenum:res[2]
        }
      } else{
        return {gapdays:0,pledgedays:0,startprenum:0}
      }
    },
    [account, contract]
  );

  //  function lockedTokens (address user,uint256 amount) public payable whenNotPaused {
  const balanceOf = useCallback(
    async (setLoading) => {
      const res= await CallFun(
        contract,
        account,
        "balanceOf",
        [ account ],
        setLoading
      );
      if (res){
        return {
          allamount:res[0],
          lockedammout:res[1],
          unlockammout:res[2],
          withdrawammout:res[3],
          canwithdrawbalance:res[4]
        }
      } else{
        return {allamount:1,lockedammout:0,unlockammout:0,withdrawammout:0,canwithdrawbalance:0}
      }
     
    
    },
    [account, contract]
  );


  const getPledgeList = useCallback(
    async ({ user }, setLoading) => {
      return await CallFun(
        contract,
        account,
        "getPledgeList",
        [ user ],
        setLoading
      );
    },
    [account, contract]
  );

  // 管理员提现到自己账号
  // function adminWithdraw(
  const adminWithdraw = useCallback(
    async ({ amount }, setLoading) => {
      return await SendFun(
        contract,
        account,
        "adminWithdraw",
        [ amount ],
        setLoading
      );
    },
    [account, contract]
  );

  useEffect(() => {
    const fun=async () => {
      setLockedBalance(await balanceOf());
    };
    if (web3 && contract) {
      fun();
    }
  
  }, [
    web3,
    contract,
    balanceOf,
    blockNumber,
  ]);


  return {
    LockedContract:contract,
    withdraw,
    lockedTokens,
    deposit,
    balanceOf,
    getPledgeList,
    adminWithdraw,
    getLokedRule,
    
    setToken,
    getToken,
    lockedBalance
  };
}

export default useLocked;

